var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "39px",
    viewBox: "0 0 54 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9080\u8BF7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.5489271%",
    y1: "23.9197531%",
    x2: "40.7563079%",
    y2: "40.9976106%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B3E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u6B63\\u5F0F",
    transform: "translate(-296.000000, -293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-43",
    transform: "translate(26.000000, 293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9080\\u8BF7",
    transform: "translate(270.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23\\u5907\\u4EFD",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3477493,0.275 L31.7764552,0.275 L53.6381348,30.7144808 L45.3639798,38.725 L4.76670584,38.725 L0.325512028,30.7658979 L22.3477493,0.275 Z",
    id: "\\u8DEF\\u5F84-10",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3477493,0.275 L31.7764552,0.275 L53.6381348,30.7144808 L45.3639798,38.725 L4.76670584,38.725 L0.325512028,30.7658979 L22.3477493,0.275 Z",
    id: "\\u8DEF\\u5F84-10",
    transform: "translate(27.000000, 19.500000) scale(1, -1) translate(-27.000000, -19.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.632653, 10.028571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 5.0380173e-14,
    y: 0.906585103,
    width: 17.6326531,
    height: 18.036272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8693878,7.21450882 L15.8693878,0 L1.76326531,0 L1.76326531,7.21450882 L5.0380173e-14,7.21450882 L5.0380173e-14,18.036272 L17.6326531,18.036272 L17.6326531,7.21450882 L15.8693878,7.21450882 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeWidth: 0.88,
    strokeDasharray: 0.8800000131130219
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52653061,2.71021231 L14.1061224,2.71021231 L14.1061224,8.12109392 L8.81632653,12.6301619 L3.52653061,8.12109392 L3.52653061,2.71021231 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28979592,4.51383951 L12.3428571,4.51383951 L12.3428571,6.31746671 L5.28979592,6.31746671 L5.28979592,4.51383951 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28979592,7.21928032 L12.3428571,7.21928032 L12.3428571,9.02290752 L5.28979592,9.02290752 L5.28979592,7.21928032 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#1A1A1A"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.af9421dcd6680c797eac730371d16aed.svg";
export { ForwardRef as ReactComponent };